import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "status-detail-btn-group"
};
const _hoisted_2 = {
  class: "btn-group"
};
const _hoisted_3 = {
  key: 1,
  class: "add-ip-wrap"
};
const _hoisted_4 = {
  class: "run-book"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "share-link"
};
const _hoisted_7 = ["href"];
import { toRefs, ref } from 'vue';
import { CopyDocument } from '@element-plus/icons-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadAndShareInfo',
  props: {
    mctLogUrl: {},
    ips: {},
    runBook: {},
    shareLink: {},
    traceLog: {
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const {
      mctLogUrl,
      ips,
      shareLink,
      traceLog
    } = toRefs(props);
    const copyShareLink = () => {
      navigator.clipboard.writeText(shareLink.value);
    };
    const openTraceLog = () => {
      window.open(traceLog.value, '_blank');
    };
    const openMctLogUrl = () => {
      const url = mctLogUrl.value.replace('{ips}', ips.value);
      window.open(`${url}mode=2`, '_blank');
    };
    const showAddIpInput = ref(false);
    const wireSharkIps = ref('');
    const openWireShark = () => {
      let url = mctLogUrl.value.replace('{ips}', ips.value);
      if (wireSharkIps.value ?? '' !== '') {
        url = mctLogUrl.value.replace('{ips}', wireSharkIps.value);
      }
      window.open(`${url}mode=0`, '_blank');
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        onClick: openMctLogUrl
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("Download MCT Log")])),
        _: 1
      }), _unref(traceLog) !== '' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: openTraceLog
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" Download Trace Log ")])),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = $event => showAddIpInput.value = true)
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" Download Wireshark Package ")])),
        _: 1
      }), showAddIpInput.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_input, {
        modelValue: wireSharkIps.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => wireSharkIps.value = $event),
        placeholder: "please input target ip or leave it blank as default"
      }, null, 8, ["modelValue"]), _cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "separate-ips"
      }, "Separate IPs By Comma(,)", -1)), _createVNode(_component_el_button, {
        type: "primary",
        onClick: openWireShark
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("Submit")])),
        _: 1
      })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_cache[7] || (_cache[7] = _createElementVNode("span", null, "Runbook:", -1)), _createElementVNode("span", {
        innerHTML: _ctx.runBook
      }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_cache[8] || (_cache[8] = _createElementVNode("span", null, "Share Link:", -1)), _createElementVNode("a", {
        href: _unref(shareLink),
        target: "_blank"
      }, _toDisplayString(_unref(shareLink)), 9, _hoisted_7), _createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "light",
        content: "Copy share link",
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: copyShareLink,
          class: "ml-5",
          icon: _unref(CopyDocument),
          size: "small",
          circle: ""
        }, null, 8, ["icon"])]),
        _: 1
      })])]);
    };
  }
});